// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__JNRud","header":"ClearentDisclaimer_header__3nEHe","inner":"ClearentDisclaimer_inner__1wjca"};